module.exports = __webpack_public_path__ + "static/our-clients-new-d7b92cef20761f9cf5cedebf39e68864.png";